import { AddRoad, CheckCircle, Hardware, TrendingUp } from "@mui/icons-material";
import { ERROR, INFO, SECONDARY, SUCCESS, WARNING } from "../../../app/constants/common";
import { attendanceStatsConfig } from "../../EmployeeAttendance/config/attendanceUtils";
import mcdIcon from "../../../asset/images/breakdown/mcd.png";
import sevenElevenIcon from "../../../asset/images/breakdown/7e.png";

export const attendanceStatsDataConfig = (data) => {
  const inheritedData = attendanceStatsConfig(data ?? {});
  return [inheritedData.total_employees, { ...inheritedData.active_employees, label: "Active Technician" }];
};

export const breakdownStatsData = (data) => [
  {
    id: "MCD",
    label: "Total MCD Breakdown",
    color: ERROR,
    icon: <img src={mcdIcon} alt="MCD" />,
    iconSize: 36,
    get count() {
      return data?.[this.id] || 0;
    },
  },
  {
    id: "7E",
    label: "Total 7E Breakdown",
    color: WARNING,
    icon: <img src={sevenElevenIcon} alt="7E" />,
    iconSize: 60,
    get count() {
      return data?.[this.id] || 0;
    },
  },
  {
    id: "ASSIGNED",
    label: "Total Breakdown Assigned and Ongoing",
    color: INFO,
    icon: <TrendingUp />,
    filterType: "BRKDN",
    filterStatus: ["ASSIGNED", "ONGOING", "PDG_START"],
    get count() {
      return data?.[this.id] || 0;
    },
  },
  {
    id: "COMPLETED",
    label: "Total Breakdown Under Review and Completed",
    color: SUCCESS,
    icon: <CheckCircle />,
    filterType: "BRKDN",
    filterStatus: ["CLOSED", "PDG_MGR_RV", "PDG_ADMIN_RV", "PDG_FINANCE_RV"],
    get count() {
      return data?.[this.id] || 0;
    },
  },
];

export const taskTypeCount = (data) => [
  {
    id: "QMP_DONE",
    type: "QMP",
    label: "QMP Task Done",
    color: SECONDARY,
    icon: <Hardware />,
    get count() {
      return data?.[this.id] || 0;
    },
  },
  {
    id: "QMP_UPCOMING",
    type: "QMP",
    label: "QMP Task Upcoming",
    color: SECONDARY,
    icon: <Hardware />,
    get count() {
      return data?.[this.id] || 0;
    },
  },
  {
    id: "INSTALLATION_DONE",
    type: "INSTALLATION",
    label: "Installation Done",
    color: WARNING,
    icon: <AddRoad />,
    get count() {
      return data?.[this.id] || 0;
    },
  },
  {
    id: "INSTALLATION_UPCOMING",
    type: "INSTALLATION",
    label: "Installation Upcoming",
    color: WARNING,
    icon: <AddRoad />,
    get count() {
      return data?.[this.id] || 0;
    },
  },
];
